// extracted by mini-css-extract-plugin
export default {"modalContent":"ADIhbrBl7GyOXbv559nV","title":"x6SqFaA1wdIUWerredDv","description":"DVX0iCvmo_VNO84S4af3"};